import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { useGetHomeQuery } from "@/store/rest_api";
import { differenceInDays } from "date-fns";
import { useNavigate } from "react-router-dom";
import React from "react";

export function TrialStatusBadge() {
  const { data: user } = useGetHomeQuery();
  const navigate = useNavigate();

  const organisation = user?.activeOrganisation;
  const subscriptionStatus = organisation?.subscriptionStatus;
  const trialExpirationDate = organisation?.trialExpirationDate;

  if (subscriptionStatus !== "TRIAL" || !trialExpirationDate) {
    return null;
  }

  const daysRemaining = differenceInDays(new Date(trialExpirationDate), new Date());
  const isExpiringSoon = daysRemaining <= 3;

  return (
    <Badge
      variant={isExpiringSoon ? "destructive" : "secondary"}
      className="cursor-pointer ps-0"
      onClick={() => navigate("/manage-organisation/plans")}
    >
      <Clock className="h-3 w-3 mr-1" />
      Trial: {daysRemaining}d left
    </Badge>
  );
}
